import { CustomImageType } from "~/Commons";
import {
  getOnpremCustomImageByKey,
  getOnpremCustomImages,
} from "~/components/db/CustomImageDBUtils";
import { getSignedUrlFromS3, getSignedUrlsInChunks } from "./s3Utils";

/**
 * 指定したkeysのカスタム画像を取得(署名付きURL付きのカスタム画像を取得)
 * @param keys key の配列
 * @param customImages カスタム画像の配列
 * @param systemRequirement システム要件 ("onprem" or "aws")
 * @returns CustomImageType の配列
 */
export const getCustomImagesByKeysWithSignedUrls = async (
  keys: string[],
  customImages: CustomImageType[],
  systemRequirement: string = "onprem"
): Promise<CustomImageType[]> => {
  try {
    if (systemRequirement === "onprem") {
      // オンプレ環境用のカスタム画像取得処理
      const results = await Promise.all(keys.map((key) => getOnpremCustomImageByKey(key)));
      return results.filter((result) => result !== null) as CustomImageType[];
    } else {
      // AWS環境用のカスタム画像取得処理
      const foundImages = customImages.filter((ci) => keys.includes(ci.key));
      const results: CustomImageType[] = [];

      for (const img of foundImages) {
        const signedUrl = await getSignedUrlFromS3(img.src);
        console.info(`キー ${img.key} の署名付きURL: ${signedUrl}`);
        if (signedUrl) {
          results.push({ key: img.key, src: signedUrl });
        } else {
          console.info(`キー ${img.key} の署名付きURL取得に失敗しました`);
        }
      }

      return results;
    }
  } catch (error) {
    console.error("getCustomImagesByKeysWithSignedUrls でエラーが発生しました:", error);
    return [];
  }
};

/**
 * すべてのカスタム画像を取得(署名付きURL付きのカスタム画像を取得)
 * @param customImages カスタム画像の配列
 * @param systemRequirement システム要件 ("onprem" or "aws")
 * @returns CustomImageType の配列
 */
export const getCustomImagesWithSignedUrls = async (
  customImages: CustomImageType[],
  systemRequirement: string = "onprem"
): Promise<CustomImageType[]> => {
  try {
    if (systemRequirement === "onprem") {
      // オンプレ環境用
      return await getOnpremCustomImages();
    } else {
      // AWS環境用
      return await getSignedUrlsInChunks(customImages, 5);
    }
  } catch (error) {
    console.error("getCustomImagesWithSignedUrls でエラーが発生しました:", error);
    return [];
  }
};
